var state = {
  sourceVal: ''
};
var mutations = {
  updateSourceVal: function updateSourceVal(state, sourceVal) {
    state.sourceVal = sourceVal;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations
};